export { getInitials } from './getInitials';
export { partitionAvatarGroupItems } from './partitionAvatarGroupItems';
export type { PartitionAvatarGroupItems, PartitionAvatarGroupItemsOptions } from './partitionAvatarGroupItems';
